import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { SendEmailSection } from '../../components/mi/account/sendEmail'
import { StyleBody } from '../../styles/mi'

export const SendEmail: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <SendEmailSection></SendEmailSection>
      <MiFooter />
    </StyleBody>
  )
}
